module.exports = __webpack_public_path__ + "static/media/how-to-run-multiple-instances-of-nodejs-on-multi-core.5e101672.md";